import React, { useMemo, useState } from 'react';
import { withAuth, WithAuthProps } from 'components/header/hoc/with-auth';
import { UserMenuContent } from 'components/header/components/profile/components/user-menu/user-menu-content';
import { useStoreon } from 'storeon/react';
import { isUserAuth } from 'selectors/cookie';
import { State } from 'store/types';
import { UserCircleIcon, UserIcon } from '@fronton/icons-react';
import { Badge, Modal } from 'fronton-react';
import { useShoppingList, useMobileMenuAnalyticsEvent } from 'components/header/hooks';
import { useTranslation } from 'react-i18next';
import { patchUrlByLocale } from 'utils';
import { MobileMenuLink } from './mobile-menu-link';
import { menuContent, badge, ProIconWrapper } from './styles';
import { EntryUserMenu } from './entry-user-menu';

import { ProIcon } from 'components/icons';
import {
  LOYALTY_PRO_ICON_QA,
  NEED_ACTION_BADGE_QA,
} from '../profile/components/user/constants/qa-constants';
import { useLoyaltyData } from 'common/hooks/use-loyalty-data';

export interface MobileUserMenuProps extends WithAuthProps {
  href: string;
  shoppingListUrl: string;
  isB2BEnabled: boolean;
}

export const DATA_QA_MOBILE_MENU_AUTH_LINK = 'mobile-menu-auth-link';

export const MobileUserMenuBase = (props: MobileUserMenuProps) => {
  const { href, shoppingListUrl, isB2BEnabled, ...rest } = props;
  const { cookies, isBot } = useStoreon<State>('cookies', 'isBot');

  const { fetchedLoyaltyAccountSuccess, loyaltyAccountIdentifier, keycardPro } = useLoyaltyData();

  const isAuth = isUserAuth(cookies);

  const { t } = useTranslation();

  const { shoppingListCount } = useShoppingList();

  const [show, setShow] = useState<boolean>(false);

  const onEnterClick = useMobileMenuAnalyticsEvent('Вход');
  const onProfileClick = useMobileMenuAnalyticsEvent('Профиль');

  const onClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    setShow(true);
    if (isAuth) {
      onProfileClick();
    } else {
      onEnterClick();
    }
  };

  const getBadge = useMemo(() => {
    if (!fetchedLoyaltyAccountSuccess) {
      return <></>;
    }

    const showBadge = !loyaltyAccountIdentifier;
    const showProCardLabel = keycardPro;

    if (showBadge) {
      return <Badge data-qa={NEED_ACTION_BADGE_QA} size="xs" value={1} className={badge} />;
    }

    if (showProCardLabel) {
      return (
        <ProIconWrapper data-qa={LOYALTY_PRO_ICON_QA}>
          <ProIcon />
        </ProIconWrapper>
      );
    }

    return <></>;
  }, [fetchedLoyaltyAccountSuccess, loyaltyAccountIdentifier, keycardPro]);

  return (
    <>
      {!isBot && (
        <MobileMenuLink
          icon={isAuth ? UserCircleIcon : UserIcon}
          href={href}
          text={isAuth ? t('header.main.profile') : t('header.main.enter')}
          getIsActive={() => false}
          data-qa={DATA_QA_MOBILE_MENU_AUTH_LINK}
          onClick={onClick}
          topBadge={getBadge}
        />
      )}
      <Modal show={show} onClose={() => setShow(false)} variant="curtain">
        <div className={menuContent}>
          {isAuth ? (
            <UserMenuContent
              shoppingListUrl={patchUrlByLocale({ url: shoppingListUrl })}
              shoppingListCount={shoppingListCount}
              {...rest}
            />
          ) : (
            <EntryUserMenu loginPageUrl={href} isB2BEnabled={isB2BEnabled} />
          )}
        </div>
      </Modal>
    </>
  );
};

export const MobileUserMenu = withAuth(MobileUserMenuBase);
